module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_114_16.d8ba2f78.pdf";